module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAVCAMAAADGtsa9AAAAM1BMVEUAAAAtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS1GE5+gAAAAEHRSTlMAv+9/EHDfr59AYM+PUDAgh7bLxAAAALNJREFUOMul1FsOhCAMBdCWR3mNzt3/aseMUZSqxHA+CZdAgdLf1zIAEzJ1Oc9YsHd1zGJjpk7cm32q3VYsOIiP8YgDXrdQcGIf4h+chHXzjXQbT2h4ImfQ4Nu8oGEceSjzTXyGkomh2P7pawVwNXiNoUjN9wtQoL3JYzAvg3mGYkbr/+b+E5Q8+v5G3/+CX/0//dcd9+JVvGwVdq+BJHo2yX52f2pqBihxor4cBJCQ1+bzA2s+KGn46qIKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/icon_point2.png
// module id = 164
// module chunks = 0